import { render, staticRenderFns } from "./MainContainer.vue?vue&type=template&id=5bd31f3e&scoped=true&"
import script from "./MainContainer.vue?vue&type=script&lang=js&"
export * from "./MainContainer.vue?vue&type=script&lang=js&"
import style0 from "./MainContainer.vue?vue&type=style&index=0&id=5bd31f3e&lang=scss&scoped=true&"
import style1 from "./MainContainer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd31f3e",
  null
  
)

export default component.exports